import { OPTIMIZELY_VARIATION_EXPRESS_CHECKOUT } from 'plugins/optimizely/hooks/use-feature-variation';
import { getFeatureFromCookieWithFallback, IMMEDIATE_FEATURES, } from 'utils/experiment';
import ErrorUtils from 'utils/error-utils';
import Config from '@/config/index';
import trackExpressEligibilityDetermined from 'segment/events/express-eligibility-determined';
export const isExpressCheckoutEligible = ({ spot, searchRequest, isRebookingReservation, eventPackage, isAdmin, optimizely, }) => {
    let isEligible = false;
    if (Config.isDev && !Config.isDeployed) {
        trackExpressEligibilityDetermined({
            isAdmin,
            isEligible,
            isEventPackage: null,
            spotIsOn: null,
            isMonthly: null,
            isRebooking: null,
            badConfig: true,
        });
        return false;
    }
    if (!optimizely) {
        trackExpressEligibilityDetermined({
            isAdmin,
            isEligible,
            isEventPackage: null,
            spotIsOn: null,
            isMonthly: null,
            isRebooking: null,
            badOptimizelyLoad: true,
        });
        return false;
    }
    if (!spot.selectedRate) {
        trackExpressEligibilityDetermined({
            isAdmin,
            isEligible,
            isEventPackage: null,
            spotIsOn: null,
            isMonthly: null,
            isRebooking: null,
            selectedRatePresent: false,
        });
        return false;
    }
    try {
        const { monthly: isMonthly, rebook_reservation_id: rebookId, } = searchRequest;
        const isEventPackage = Boolean(eventPackage?.id);
        const isVerticalExpressAllowed = !isMonthly && !isEventPackage;
        const isRebooking = Boolean(rebookId || isRebookingReservation);
        const freePark = spot.requireCreditCard === false;
        if (!freePark && isVerticalExpressAllowed && !isRebooking && !isAdmin) {
            isEligible = true;
        }
        trackExpressEligibilityDetermined({
            isAdmin,
            isEligible,
            isEventPackage,
            spotIsOn: null,
            isMonthly,
            isRebooking,
        });
        if (isEligible) {
            isEligible =
                getFeatureFromCookieWithFallback(optimizely, IMMEDIATE_FEATURES.EXPRESS_CHECKOUT_WEB_DESKTOP_REFRESH, { generateImpression: true }) === OPTIMIZELY_VARIATION_EXPRESS_CHECKOUT;
        }
    }
    catch (e) {
        ErrorUtils.sendSentryMessage({
            error: e,
            // STRICT - @ts-expect-error - Error Utils not typed yet - need to fix
            customErrorMessage: 'Error in isExpressCheckoutEligible',
        });
    }
    return isEligible;
};
